import { render } from "./ui-modal.vue?vue&type=template&id=3d877b02&scoped=true"
import script from "./ui-modal.vue?vue&type=script&lang=js"
export * from "./ui-modal.vue?vue&type=script&lang=js"

import "./ui-modal.vue?vue&type=style&index=0&id=3d877b02&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d877b02"]])

export default __exports__